import { useLocation } from "react-router";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import type { Approval } from "../../../api/types/approvalTypes";
import { getReferrerLocationState } from "../../../utilities/navigationHelper";
import { getApprovalNavigationPath } from "../../approvals/approvalsHelper";

interface Props {
  row: Approval;
}

const ApprovalItemNameCell = ({ row }: Props) => {
  const location = useLocation();

  return (
    <GridTextHoverLink
      to={getApprovalNavigationPath(row)}
      state={getReferrerLocationState(location)}
      text={row.itemName}
    />
  );
};

export default ApprovalItemNameCell;
